<ion-item [disabled]="disabled && !transitEditable">
  <ion-label>Asistent</ion-label>
  @if (assignments$$ | async; as assignments) {
    <ion-grid class="wrapper">
      @for (a of assignments; track a) {
        <ion-row class="assignment">
          <ion-col class="status">
            <span
              class="content"
              [style.background-color]="a.status.color"
              (click)="onAssignmentNameClick($event)"
              title="{{ a.fullname }}"
            >
              {{ a.fullname }}
            </span>
          </ion-col>
          <ion-col class="transit">
            <span class="content">
              přejezd
              <ion-input
                #transitDurationInput
                type="number"
                min="0"
                step="5"
                name="assignment-{{ a.id }}-transit-duration"
                [disabled]="
                  (disabled && !transitEditable) || (!areAssignmentsEditable && keepAssignmentEditable !== a.id)
                "
                [value]="+a.transitDurationMinutes"
                (ionChange)="onTransitDurationChange($event, a.id)"
              ></ion-input>
              min
            </span>
          </ion-col>
        </ion-row>
      }
    </ion-grid>
  }
</ion-item>
